<template>
  <div :class="$style.container">
    <header :class="$style.header">
      Local Device Accounts
    </header>
    <div :class="$style.tableContainer">
      <InsightsMultiItemTable
        :exportEnabled="false"
        :filter="filter"
        metricGroup="users"
        :systemId="item.id"
      />
    </div>
  </div>
</template>

<script>
import InsightsMultiItemTable from 'client/systems/systemInsights/components/InsightsMultiItemTable';
import SystemInsightsComponentMixin from '../mixins/SystemInsightsComponentMixin';

export default {
  name: 'LocalAccountsInsights',

  components: {
    InsightsMultiItemTable,
  },

  mixins: [SystemInsightsComponentMixin],

  data: () => ({
    filter: ['real_user:eq:true'],
  }),

};
</script>

<style module>
@import '../css/systemInsights.css';

.tableContainer {
  padding: 0 10px 10px 10px;
  position: relative;
}
</style>
